import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Plazos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Tipo",
                    id: "tipo",
                    accessor: d => (d.tipo == 0 ? "UVT" : "OTT"),
                    show: true,
                },
                {
                    Header: "Email",
                    id: "email",
                    accessor: d => d.email,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        permission: 'uvt_add',
                        component: Create,
                    },
                    {
                        edit: true,
                        permission: 'uvt_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'uvt_detail',
                        component: Detail,
                    },
                    {
                        edit: true,
                        permission: 'uvt_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.proyectos.config.presupuesto.uvt.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.config.presupuesto.uvt.export}
                title={"OTT - UVT"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default Plazos;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_UVT/UVT.js